import { render, staticRenderFns } from "./AutocreditPendingReview.vue?vue&type=template&id=4fe1d874&scoped=true&"
import script from "./AutocreditPendingReview.vue?vue&type=script&lang=ts&"
export * from "./AutocreditPendingReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1d874",
  null
  
)

export default component.exports